import { X } from 'lucide-react';
import { Button } from './button';
import { cn } from './utils';

interface CloseButtonProps {
  onClick: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function CloseButton({ onClick, className, size = 'md' }: CloseButtonProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className={cn(
        sizeClasses[size],
        'rounded-xl border border-gray-200 hover:bg-gray-100 hover:border-gray-300 transition-all',
        'shadow-sm hover:shadow-md',
        className
      )}
    >
      <X className={cn(iconSizes[size], 'text-gray-600')} />
      <span className="sr-only">Fermer</span>
    </Button>
  );
}